module.exports = __webpack_public_path__ + "img/logo.6bc6ed80.svg";